export function getAvailability(term) {
  // Vakanza blokuje zwykłą rezerwację, ale pozwala przejść na listę rezerwową.
  if (term.isLocked === true) {
    return {
      label: 'Brak miejsc',
      variant: 'sold-out',
      bookingEnabled: true,
      bookingLabel: 'Lista rezerwowa',
    }
  }

  const totalSeats = Number(term.totalSeats)
  const seatsAvailable = Number(term.seatsAvailable)

  if (
    !Number.isFinite(totalSeats) ||
    !Number.isFinite(seatsAvailable) ||
    totalSeats <= 0
  ) {
    return {
      label: 'Sprawdź dostępność',
      variant: 'unknown',
      bookingEnabled: false,
      bookingLabel: 'Rezerwacja niedostępna',
    }
  }

  const placesLeft = Math.max(
    0,
    Math.min(seatsAvailable, totalSeats)
  )

  const booked = totalSeats - placesLeft

  if (placesLeft === 0) {
    return {
      label: 'Brak miejsc',
      variant: 'sold-out',
      bookingEnabled: false,
      bookingLabel: 'Brak miejsc',
    }
  }

  // Przy maksymalnie czterech wolnych miejscach pokazujemy dokładną liczbę.
  if (placesLeft <= 4) {
    return {
      label: placesLeft === 1
        ? '1 Ostatnie miejsce'
        : `${placesLeft} Ostatnie miejsca`,
      variant: 'last-places',
      bookingEnabled: true,
      bookingLabel: 'Rezerwuj',
    }
  }

  // „Ostatnie miejsca” pojawiają się po zebraniu ponad połowy grupy.
  // Przykład: 9 rezerwacji na 16 miejsc lub 7 rezerwacji na 12 miejsc.
  if (booked > totalSeats / 2) {
    return {
      label: 'Ostatnie miejsca',
      variant: 'last-places',
      bookingEnabled: true,
      bookingLabel: 'Rezerwuj',
    }
  }

  return {
    label: 'Dostępne miejsca',
    variant: 'available',
    bookingEnabled: true,
    bookingLabel: 'Rezerwuj',
  }
}
